module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Tools-7e190b501304d7b2cf016ef2a9ed7a57.svg";